/**
 * Abre o terminal RouterOS em janela popup dedicada.
 * O destino é /router-terminal/:routerId (rota sem Layout do painel).
 */
export function openRouterConsoleWindow(routerId) {
  const id = encodeURIComponent(String(routerId).trim())
  const url = `${window.location.origin}/router-terminal/${id}`
  const w = Math.min(1320, window.screen.availWidth - 80)
  const h = Math.min(860, window.screen.availHeight - 80)
  const left = Math.max(0, Math.round((window.screen.availWidth - w) / 2))
  const top = Math.max(0, Math.round((window.screen.availHeight - h) / 2))
  const features = [
    'popup=yes',
    `width=${w}`,
    `height=${h}`,
    `left=${left}`,
    `top=${top}`,
    'menubar=no',
    'toolbar=no',
    'location=no',
    'status=no',
    'scrollbars=no',
    'resizable=yes',
  ].join(',')
  const name = `automais-router-console-${id}`
  const win = window.open(url, name, features)
  if (win) win.focus()
  return win
}
